import { Dawa } from "../../../../../core/domain/models";
import { DawaWebEntity } from './dawa-web-entity';
import { Mapper } from "../../../../../core/base";
import { AdresseWebRepositoryMapper } from "./adresse-web-repository-mapper";

export class DawaWebRepositoryMapper extends Mapper<DawaWebEntity, Dawa> {
  mapFrom(param: DawaWebEntity): Dawa {
    const addressWebRepositoryMapper = new AdresseWebRepositoryMapper(); 
    return {
      text: param.tekst,
      address: addressWebRepositoryMapper.mapFrom(param.adresse)
    };
  }

  mapTo(param: Dawa): DawaWebEntity {
    const addressWebRepositoryMapper = new AdresseWebRepositoryMapper(); 
    return {
        tekst : param.text,
        adresse : addressWebRepositoryMapper.mapTo(param.address)
    };
  }
}
